import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { DateTime } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { getCalendarEventsByDateTime } from '@mews-commander/legacy-entities/src/ducks/calendarEvents';
import { HeaderCellElement } from './styles';

interface StateProps {
    calendarEvents: unknown;
}
interface OwnProps {
    date: DateTime;
}

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        calendarEvents: getCalendarEventsByDateTime,
    })
)(HeaderCellElement);
